import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

/** Action module. */
export const actionModule = {
    state,
    getters,
    mutations,
    actions,
};
